import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf255cae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"width":"3rem","height":"3rem"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = {
  key: 2,
  class: "text-center",
  style: {"color":"#072878"}
}
const _hoisted_6 = { class: "row justify-content-between text-center" }
const _hoisted_7 = { class: "col col-lg-4 text-start" }
const _hoisted_8 = { class: "col col-lg-4 text-end" }
const _hoisted_9 = {
  key: 3,
  class: "row"
}
const _hoisted_10 = { class: "card chapter-card" }
const _hoisted_11 = {
  class: "background-block",
  style: {"background-color":"#072878"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, /*#__PURE__*/_toDisplayString('Páginas'), -1))
const _hoisted_13 = { class: "card-content" }
const _hoisted_14 = { class: "read-more" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Leer")
const _hoisted_16 = { class: "row justify-content-between text-center" }
const _hoisted_17 = { class: "col col-lg-4 text-start" }
const _hoisted_18 = { class: "col col-lg-4 text-end" }

import { ref, onMounted, Ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/es-mx'
import { Story, Chapter } from '@/data/models/Story'
import StoryDao from '@/data/dao/StoryDao'
import ChapterDao from '@/data/dao/ChapterDao'
import Resource from '@/data/tools/Resource'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChaptersPage',
  setup(__props) {

dayjs.extend(relativeTime)
dayjs.locale('es-mx')

const router = useRouter()
const route = useRoute()

const s = new StoryDao
const c = new ChapterDao

const story: Ref<Story | null> = ref(null)

const firstChapter: Ref<Chapter | null> = ref(null)
const lastChapter: Ref<Chapter | null> = ref(null)

const showBackButton = ref(false)
const showNextButton = ref(false)
const loading = ref(false)
const error = ref(false)

function checkButton(){
  if(story.value!.chapters!.length > 0){
    (story.value!.chapters![0].id === firstChapter.value?.id) ? showBackButton.value = false : showBackButton.value = true,
    (story.value!.chapters![story.value!.chapters!.length - 1].id === lastChapter.value?.id) ? showNextButton.value = false : showNextButton.value = true
  }else{
    showBackButton.value = false
    showNextButton.value = false
  }
}

function showPages(item: Chapter){
  router.push(`/storie/${route.params.id_story.toString()}/chapter/${item.id}/page/1`)
}

async function getStory(){
  await s.getStory(route.params.id_story.toString(), (resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        story.value = resource.data
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getChapters(){
  await c.getChapters(story.value!.id, (resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        story.value!.chapters = [...resource.data]
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getFirstChapter(){
  await c.getFirstChapter(story.value!.id, (resource: Resource) => {
    switch(resource.status){
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        firstChapter.value = { ...resource.data[0] }
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getLastChapter(){
  await c.getLastChapter(story.value!.id, (resource: Resource) => {
    switch(resource.status){
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        lastChapter.value = { ...resource.data[0] }
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getBackChapters(){
  await c.getBackChapters(story.value!.id, (resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        story.value!.chapters = [...resource.data]
        checkButton()
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getNextChapters(){
  await c.getNextChapters(story.value!.id, (resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        story.value!.chapters = [...resource.data]
        checkButton()
        loading.value = false
        break
      default:
        break
    }
  })
}

onMounted(async() => {
  if(route.params.id_story){
    await getStory()
    if(story){
      await getChapters()
      await getFirstChapter()
      await getLastChapter()
      checkButton()
    }else{
      router.replace('/stories')
    }
  }else{
    router.replace('/stories')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Error obteniendo los capítulos! "))
      : _createCommentVNode("", true),
    (story.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(story.value.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (showBackButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getBackChapters
            }, "Atrás"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (showNextButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getNextChapters
            }, "Siguiente"))
          : _createCommentVNode("", true)
      ])
    ]),
    (story.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(story.value.chapters, (c, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-3 col-md-6 mb-5",
              key: i
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("h1", null, _toDisplayString(c.numberPages), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h2", null, [
                    _createTextVNode(_toDisplayString(c.title), 1),
                    _createElementVNode("small", null, _toDisplayString(`Creado: ${_unref(dayjs)(c.created * 1000).fromNow()}`), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      style: {"color":"#072878"},
                      to: "#",
                      onClick: ($event: any) => (showPages(c))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        (showBackButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getBackChapters
            }, "Atrás"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (showNextButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getNextChapters
            }, "Siguiente"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})